import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { del } from 'utils/http'

export const useCustomerDomainRemove = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const removeDomain = async (id: any) => del(`/management/customers/${customerId}/domains/${id}`)

  return useMutation({
    mutationFn: removeDomain,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'domains'] })

      addNotification('Domain removed successfully', 'success')
    },
  })
}
